<template>
    <div id="logout-button" v-if="logoutbutt">
        <v-btn class="hidden-sm-and-down" @click="logout" flat style="height:100%;width:20vw;padding:0;" slot="activator"><v-img :src="logout_img_path" /></v-btn>          
    </div>
</template>

<script>
// import { uuid } from 'vue-uuid';

let language=localStorage.getItem('language');
var logged = false;

export default {
    
    beforeCreate() {                
        var token = localStorage.getItem('token')        
        if(token!==null){            
            logged = true;      
        }        
    },
    data(){
        if (language=='es') 
        {
            return{                
                logout_img_path:'./cerrarsesion.png',
                logoutbutt:logged
            }
        }else{
            return{                
                logout_img_path:'./logout.png',   
                logoutbutt:logged         
            }
        }
    },
    methods:{
    logout: function () {              
        this.$store.dispatch('logout')
       .then( () =>
           //location.reload()
           this.$router.push('/')
       ).catch(function () {
           alert("Hubo un problema favor de intentarlo mas tarde");
           this.$router.push('/')
       }
       )
      }
    }
}
</script>